import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormDetailsReportFields } from 'src/app/reports/form-details-report/form-details-report.fields';
import { FilterOperatorType } from 'src/app/shared/components/odata-filter/models/filter-operator-type';
import { OPERATORS } from 'src/app/shared/components/odata-filter/models/operators';
import { SelectedFilter } from 'src/app/shared/components/odata-filter/models/selected-filter';
import { FORM_SYSTEM_FILTER_MODELS } from 'src/app/shared/components/odata-filter/models/system-filter-models';
import { ApiVersions } from 'src/app/shared/services/api-version';
import { BaseODataService } from 'src/app/shared/services/base-odata.service';
import { last30Days } from 'src/app/shared/utils/date-utils';
import { LatestFormSubmissionRow } from './latest-form-submission-row.model';

@Injectable()
export class LatestFormSubmissionsService extends BaseODataService {
  public readonly latestFormSubmissions = new Subject<LatestFormSubmissionRow[]>();
  private _requestSubscription: Subscription;

  constructor() {
    super();
    this._baseUrl = 'applicationReport';
  }

  getLatestFormSubmissions(formId: string) {
    let queryParams = {
      select: [
        FormDetailsReportFields.id,
        FormDetailsReportFields.formName,
        FormDetailsReportFields.respondentId,
        FormDetailsReportFields.respondentFullName,
        FormDetailsReportFields.formStatus,
        FormDetailsReportFields.submissionDate
      ],
      filter: this.buildFilter(this.generateFilters(formId)),
      orderBy: [`${FormDetailsReportFields.submissionDate} desc`],
      top: 25,
      count: false
    };

    this._requestSubscription?.unsubscribe();
    this._requestSubscription = this.getODataResult(
      this.allResultsFilterUrl,
      queryParams,
      ApiVersions.unversioned
    )
      .pipe(
        map((response) => {
          if (response && response.value) {
            return response.value.map((v) => new LatestFormSubmissionRow(v));
          } else {
            return [];
          }
        })
      )
      .subscribe((result) => this.latestFormSubmissions.next(result));
  }

  private generateFilters(formId: string) {
    let filters = [
      new SelectedFilter({
        filter: FORM_SYSTEM_FILTER_MODELS.FormSubmissionDateFilterModel,
        filterOperator: OPERATORS.Date.operators.find(
          (op) => op.displayOperator == FilterOperatorType.gt
        ),
        searchValue: last30Days()
      })
    ];

    if (formId) {
      filters.push(
        new SelectedFilter({
          filter: FORM_SYSTEM_FILTER_MODELS.FormIdFilterModel,
          filterOperator: OPERATORS.Guid.operators.find(
            (op) => op.displayOperator == FilterOperatorType.eq
          ),
          searchValue: formId
        })
      );
    }
    return filters;
  }
}
